import React, { useEffect } from 'react';
import { Modal } from '@encarpkg/design';
import { Enlog } from '@encarpkg/shared';

/** 기존 가입 이력 존재 시 신규가입 확인 모달 문구 */
const MODAL = {
	TITLE: '가입된 이력이 있어요.\n새로 가입을 진행할까요?',
	SUBTITLE: '취소 시 로그인 화면으로 이동해요.',
	CANCEL: '취소',
	SUBMIT: '새로 가입',
};

const ENLOG_EVENT_NAME_GROUP = '가입이력존재_팝업';

function DuplicateJoinConfirmModal({ isOpen, onCancel, onConfirm }) {
	useEffect(() => {
		if (isOpen) {
			Enlog().enloggingJsonData({
				dataTalkViewSingle: {
					screenname: '회원가입_정보입력',
					eventnamegroup: ENLOG_EVENT_NAME_GROUP,
				},
			});
		}
	}, [isOpen]);

	return (
		<Modal.V2Renew
			isOpen={isOpen}
			onClose={onCancel}
			title={MODAL.TITLE}
			subtitle={MODAL.SUBTITLE}
			buttonModuleType="vertical"
			buttonModuleProps={{
				cancelButtonProps: {
					color: 'gray',
					children: MODAL.CANCEL,
					'data-enlog-dt-eventnamegroup': ENLOG_EVENT_NAME_GROUP,
					onClick: onCancel,
				},
				okButtonProps: {
					children: MODAL.SUBMIT,
					'data-enlog-dt-eventnamegroup': ENLOG_EVENT_NAME_GROUP,
					onClick: onConfirm,
				},
			}}
		/>
	);
}

export default DuplicateJoinConfirmModal;
